import { useEffect } from 'react';
import { useBooleanState } from './hooks';
export const useNodeEditing = ({ nodeRef, view, }) => {
    const state = useBooleanState(false);
    const [, , unsetEdit, toggleEdit] = state;
    useEffect(() => {
        const { current: anchor } = nodeRef;
        anchor === null || anchor === void 0 ? void 0 : anchor.addEventListener('dblclick', toggleEdit);
        view.dom.addEventListener('focus', unsetEdit);
        return () => {
            anchor === null || anchor === void 0 ? void 0 : anchor.removeEventListener('dblclick', toggleEdit);
            view.dom.removeEventListener('focus', unsetEdit);
        };
    }, [nodeRef.current, view.dom, toggleEdit, unsetEdit]);
    return state;
};
